// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { TestBed } from '@angular/core/testing';

export const environment = {
  production: false,

  platformName: 'AppCore',
  platformVersion: '1.0',  
  additionalApiNamespace: 'UltraRSS',
  titleToDisplay: 'UltraRSS',
  applicationKey: '78F1621A-1738-4F40-98CA-E172EF2EF1A9',
  defaultEmail: 'eunae@ultrarss.com',
  defaultChannelImageUrl: 'http://ultrarss.com/assets/ultrarss.png',
  defaultChannelItemImageUrl: 'http://ultrarss.com/assets/no-image-icon.png'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
